import HubEpworthQuizResultsModule from './HubEpworthQuizResultsModule'

export default HubEpworthQuizResultsModule
